<div id="chart-box">
  <div class="chart-wrapper">
    <div class="fixedArea">
      <canvas [id]="chartId + 'fixedChart'"></canvas>
    </div>
    <div class="scrollArea">
      <div class="box" #chartBox>
        <canvas [id]="chartId + 'scrollChart'"></canvas>
      </div>
    </div>
  </div>
</div>
